import { IndexLayout } from './IndexLayout';

export default IndexLayout;
